export const environment = {
  production: false,
  base_url: 'https://help.eeviction.com',
  api_prefix: 'https://api.eeviction.com/',
  portal_url: 'https://portal.eeviction.com',
  cognito_domain: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_nVdvRO67P',
  cognito_custom_domain: 'us-east-1nvdvro67p.auth.us-east-1.amazoncognito.com',
  cognito_clientid: 'irif1ovl9jsduqrs59e8nadq0',
  version: '19e5d36e1711bea5a285d639d5bac318df966826',
};
